module.exports = "https://static.wanderu.com/static/media/mashable-x2.29e1f91a.png";